import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const BackLogin = () => {
  const navigate = useNavigate();
  return (
    <Button sx={{ color: "#2a9941" }} onClick={() => navigate("/sign-in")}>
      Back to login
    </Button>
  );
};

export default BackLogin;
